import React, { useState, useEffect } from "react";
import styles from "./App.module.css";
import { Header } from "./components/Header/Header";
import { Sidebar } from "./components/Sidebar/Sidebar";

import { Routes, Route, Navigate } from "react-router-dom";
import { Relatorios } from "./components/Pages/Relatorios/Relatorios";
import { Finances } from "./components/Pages/Finances/Finances";
import { Login } from "./components/Pages/Login/Login";
import { Profile } from "./components/Pages/Profile/Profile";

import { ProtectedRoute } from "./components/ProtectedRoute/ProtectedRoute";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { SnackbarProvider } from "notistack";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/pt-br';


// Componente interno que usa o contexto de autenticação
function AppContent() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    return window.innerWidth > 1024;
  });
  const { isAuthenticated } = useAuth();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  // Listener para redimensionamento da janela
  useEffect(() => {
    const handleResize = () => {
      // Se mudou para desktop, abre o sidebar
      if (window.innerWidth > 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/finances"
        element={
          <ProtectedRoute>
            <div className={`${styles.appGrid} ${!isSidebarOpen ? styles.sidebarClosed : ''}`}>
              <Header onToggleSidebar={toggleSidebar} />
              <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
              <div className={styles.contentArea}>
                <Finances />
              </div>
            </div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/relatorios"
        element={
          <ProtectedRoute>
            <div className={`${styles.appGrid} ${!isSidebarOpen ? styles.sidebarClosed : ''}`}>
              <Header onToggleSidebar={toggleSidebar} />
              <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
              <div className={styles.contentArea}>
                <Relatorios />
              </div>
            </div>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <div className={`${styles.appGrid} ${!isSidebarOpen ? styles.sidebarClosed : ''}`}>
              <Header onToggleSidebar={toggleSidebar} />
              <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
              <div className={styles.contentArea}>
                <Profile />
              </div>
            </div>
          </ProtectedRoute>
        }
      />

      <Route 
        path="/" 
        element={
          isAuthenticated ? <Navigate to="/finances" /> : <Navigate to="/login" />
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </SnackbarProvider>
    </LocalizationProvider>
  );
}

export default App;
